import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "nave-card" }
const _hoisted_2 = { class: "nave-card__head" }
const _hoisted_3 = {
  key: 0,
  class: "nave-card__tip"
}
const _hoisted_4 = { class: "nave-card__head-content" }
const _hoisted_5 = { class: "nave-card__title-content" }
const _hoisted_6 = { class: "nave-card__title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "nave-card__subtitle" }
const _hoisted_9 = { class: "nave-card__alerts-insights" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "nave-card__selects" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tip_bar = _resolveComponent("tip-bar")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_select_monitoring_alert = _resolveComponent("select-monitoring-alert")!
  const _component_be_max_modal = _resolveComponent("be-max-modal")!
  const _component_nave_select = _resolveComponent("nave-select")!
  const _component_date_range = _resolveComponent("date-range")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showTipBar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_ctx.tipState)
                ? (_openBlock(), _createBlock(_component_tip_bar, {
                    key: 0,
                    tip: _ctx.tipBar,
                    onActiveLink: _ctx.openTipBarContent,
                    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeStateTip(true))),
                    close: true,
                    class: "mb-5 nave-card__tip-bar"
                  }, null, 8, ["tip", "onActiveLink"]))
                : _createCommentVNode("", true),
              (_ctx.tipState)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "general-performance__btn-tip d-flex align-items-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStateTip(false)))
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "icon-nave-icon-lamb" }, null, -1),
                    _createElementVNode("span", null, "entenda origem dos dados", -1),
                    _createElementVNode("i", { class: "icon-nave-arrow-down" }, null, -1)
                  ])))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "logo"),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, [
              _createElementVNode("span", { innerHTML: _ctx.title }, null, 8, _hoisted_7),
              (_ctx.tooltip)
                ? (_openBlock(), _createBlock(_component_tooltip, {
                    key: 0,
                    title: _ctx.tooltip,
                    html: _ctx.html
                  }, null, 8, ["title", "html"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h2", _hoisted_8, [
              _renderSlot(_ctx.$slots, "subtitle")
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.alerts.length > 0)
                ? (_openBlock(), _createBlock(_component_select_monitoring_alert, {
                    key: 0,
                    title: _ctx.title,
                    alerts: _ctx.alerts
                  }, null, 8, ["title", "alerts"]))
                : _createCommentVNode("", true),
              _createVNode(_component_be_max_modal, {
                beMax: _ctx.beMax,
                mode: "line"
              }, null, 8, ["beMax"])
            ])
          ]),
          (_ctx.linkUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.linkUrl,
                target: "_blank",
                class: "nave-card__link"
              }, [
                _createTextVNode(_toDisplayString(_ctx.linkText) + " ", 1),
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.linkIcon)
                }, null, 2)
              ], 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.checkOptions)
            ? (_openBlock(), _createBlock(_component_nave_select, {
                key: 0,
                options: _ctx.selectOptions,
                onOptionSelected: _ctx.optionSelected
              }, null, 8, ["options", "onOptionSelected"]))
            : _createCommentVNode("", true),
          (_ctx.checkDate)
            ? (_openBlock(), _createBlock(_component_date_range, {
                key: 1,
                time: _ctx.datePeriod,
                onDateUpdated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDate($event)))
              }, null, 8, ["time"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}